// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__jw-oW","colMin":"styles_colMin__23S__","colCheckbox":"styles_colCheckbox__3EVkS"};